import { applyKeepAwake } from '~/utils/keepAwake'

/**
 * Keep the Screen Awake (Settings): take the screen's wake lock at start when the driver turned
 * it on, and again every time the page comes back, because the browser lets it go whenever the
 * page is hidden. The rule is in utils/keepAwake.ts.
 */
export default defineNuxtPlugin(() => {
  void applyKeepAwake()
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') void applyKeepAwake()
  })
})
